export default __webpack_public_path__ + "static/media/th-ico.848732f2.svg";